import React,{useState,useEffect} from 'react'
import AppHeader from '../../components/AppHeader'
import portalServices from '../../portalServices';
import { useLocation, useNavigate, useParams } from 'react-router-dom';


import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { useAlert } from '../../../../context/AlertContext';
import { ArrowBack, ArrowCircleRight } from '@mui/icons-material';

import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
const Step2 = ({queue}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={1}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Select Time Slot And Service</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}

function SelectSlotServicesPage() {

	const location = useLocation();
	const queue = location.state;

	const queueId = queue?queue.id:null;
	const navigate = useNavigate();
	const {AppAlert} = useAlert();
	const [availableTimeSlots,setAvailableTimeSlot] = useState(null);

	const [selectedDate,setSelectedDate] = useState(null);
	const [selectedTime,setSelectedTime] = useState(null);

	const getAvailableTimeSlots = () =>{
		setSelectedTime(null);
		if(selectedDate !== null){
			setAvailableTimeSlot(null);
			let payload = {
				date: moment(selectedDate).format("YYYY-MM-DD"),
				queueId:queueId,
			}
			portalServices.getAvailableTimeSlots(payload).then(res=>{
				setAvailableTimeSlot(res.data);
			}).catch(error=>{
				AppAlert(error.msg,"error")
			})
		}
	}
	useEffect(()=>{
		getAvailableTimeSlots();
	},[selectedDate])

	const [serviceList,setServiceList] = useState(null);
	const getServiceList = () =>{
		portalServices.getServiceList(queueId).then(res=>{
		setServiceList(res.data);
		}).catch(error=>{
		})
	}
	useEffect(()=>{
		getServiceList();
	},[])


	const selectService = (service) =>{
		navigate("/slot-checkin/form",{state:{queue,queue,service,service,selectedDate, selectedTime, selectedDate}})
	}

	useEffect(()=>{
		if(queue==null){
			navigate("/slot-checkin/queue")
		}
	},[])

  	return (
    <>
        <AppHeader/>
		{queue &&
        <div className='container'>
            <div className='row'>
				<CheckinBackButton/>
				<Step2 queue={queue} />
				<div className='col-md-4'>  
						<Calendar 
							onChange={setSelectedDate} 
							value={selectedDate}
							minDate={moment().add(0,"day").toDate()} 
							maxDate={moment().add(queue.maxFutureDays,"day").toDate()}   
						/>
				</div>

				{selectedDate &&
					<div className='col-md-8'>
						{selectedTime === null ?
							<div className='card'>
								<div className='card-header bg-dark text-white'>Select Time</div>
								<div className='card-body'>
									<div className='row'>
										{availableTimeSlots && availableTimeSlots.map((timeSlot,i)=>
											timeSlot.slots > 0 &&
											<div className='col-md-4'>
												<div  key={timeSlot.displayTime} className="card mb-2" type="button"
													onClick={()=>{
														setSelectedTime(timeSlot)
													}}
												>
													<div className="card-header bg-success text-white py-1 text-center"> {timeSlot.displayTime} </div>
													<small className="text-center">{timeSlot.slots > 1 ?
															timeSlot.slots+" Slots Left"
															:
															"Only 1 Slot Left"
														}
													</small>
												</div>
											</div>
										)}
									</div>
								</div>
							</div>
						:
							<div className='card'>
								<div className='card-header bg-dark text-white'>Select Service</div>
								<div className='card-body'>
									<div className='d-flex justify-content-between mb-3'>
											<button className='btn btn-danger' onClick={()=>setSelectedTime(null)}> <ArrowBack/> Change Time</button>
											<h3>{selectedTime.displayTime}</h3>
									</div>
									{serviceList && serviceList.map(service=>
										<div key={service.id} className="card px-3 py-3 mb-2" onClick={()=>selectService(service)} style={{cursor:"pointer"}}>
											<div className=' d-flex justify-content-between'>
												<div className='fw-bold'>{service.title}</div>
												<ArrowCircleRight/>
											</div>
										</div>
									)}
								</div>
							</div>
						}
						
					</div>
				}
            </div>
        </div>
		}
		
    </>
  )
}

export default SelectSlotServicesPage